module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-laugh-evil-sad-svgrepo-com.9585d79c.svg";